import { 
    MDBCollapse, 
    MDBContainer, 
    MDBIcon, 
    MDBNavbar, 
    MDBNavbarBrand, 
    MDBNavbarItem, 
    MDBNavbarLink, 
    MDBNavbarNav,
    MDBNavbarToggler,
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
} from 'mdb-react-ui-kit'

import Dropdown from 'react-bootstrap/Dropdown';
import { videoInfoLink } from '../data';

import { useState } from 'react';
import VideoPlayerModal from './VideoPlayerModal';

const Navbar = () => {
    const [centredModal, setCentredModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const [title, setTitle] = useState(null)
    const [videoLink, setVideoLink] = useState(null)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const playVideo = (link, titleData) =>{
        handleShow()
        setVideoLink(link);
        setTitle(titleData)
    }

    function toggleOpen(num){
        setCurrentIndex(num);
        setCentredModal(!centredModal);
    }
    const [openNav, setOpenNav] = useState(false);

    // console.log("Videos data:", videoInfoLink)
    return (
        <>
            <MDBNavbar expand='lg' light bgColor='light' className='justify-content-center text-end'>
                <MDBContainer fluid className='mx-1 px-1 mx-md-2 px-md-2 mx-xlg-4 navbar-max-width-set'>
                    <MDBNavbarBrand href='#' className='mx-0 px-0'>
                        <img
                        src='Image/logo.png'
                        className='logo'
                        alt=''
                        loading='lazy'
                        />
                    </MDBNavbarBrand>
                    <MDBModalHeader className='text-logo topnav-bold ms-0 ps-0 text-uppercase text-center'>
                        3D Training 
                        <br />
                        & Marketing
                    </MDBModalHeader>

                    <MDBCollapse navbar open={openNav}>
                        
                    <MDBNavbarNav right fullWidth={false} className='mb-2 mb-lg-2  topnav-bold'>
                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#SOLUTIONS'>SOLUTIONS</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#PLAYER'>PLAYERS</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#LIBRARY'>LIBRARY</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#MANAGER'>MANAGER</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#BUILDER'>BUILDER</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <MDBNavbarLink className='nav-link-top' href='#CONTACT'>CONTACT</MDBNavbarLink>
                        <div className="underline-nav"></div>
                        </MDBNavbarItem>

                        <MDBNavbarItem>
                        <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className='top-btn-link'>
                            Try Demos
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item href="https://gtienergy.paracosma.com/home"  target="_blank" > gtienergy.paracosma.com </Dropdown.Item>
                        </Dropdown.Menu>
                        </Dropdown>
                        </MDBNavbarItem>
                        <MDBNavbarItem>
                        <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className='top-btn-link-video'>
                        Watch Videos
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {videoInfoLink?.map((item) =><Dropdown.Item onClick={() => {playVideo(item.link, item.videoName)}}>{item.videoName}</Dropdown.Item>)}
                            {/* <Dropdown.Item onClick={() => {toggleOpen(0)}}>3D Training and Marketing Platform</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(1)}}>3D Training Library for Natural Gas</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(2)}}>Paracosma 3D Training Platform Feature Overview</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(3)}}>What’s a 3D Model Worth?</Dropdown.Item>

                            
                            <Dropdown.Item onClick={() => {toggleOpen(4)}}>PowerView E-Learning Content: 3D Lessons, Quizzes & Gamification</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(5)}}>PowerView Camera Controls: No-Code Lesson Creation Tool</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(6)}}>PowerView Instructional Video: Bypass Meter Set</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(7)}}>PowerView 3D UI Explorer: Service Line & Meter Set | Paracosma</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(8)}}>PowerView Training Library for Natural Gas - 3D Models Teaser | Paracosma</Dropdown.Item>
                            <Dropdown.Item onClick={() => {toggleOpen(9)}}>PowerView Interactive Training Platform - Admin Tutorial | Paracosma</Dropdown.Item> */}
                        </Dropdown.Menu>
                        </Dropdown>
                        </MDBNavbarItem>
                        
                    </MDBNavbarNav>
                    </MDBCollapse>
                    <MDBNavbarToggler
                    type='button'
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                    onClick={() => setOpenNav(!openNav)}
                    >
                    <MDBIcon icon='bars' fas />
                    </MDBNavbarToggler>
                </MDBContainer>
            </MDBNavbar>


            {videoLink && 
                <VideoPlayerModal title={title} link={videoLink} handleClose={handleClose} show={show} />
            }
        {/* <MDBModal staticBackdrop tabIndex='-1' open={centredModal} setOpen={setCentredModal}>
        <MDBModalDialog scrollable position='top-right' size="xl">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{videoInfoLink[currentIndex]?.videoName}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
            <div className="youtubePlayer-main">
            <iframe
                className="youtubePlayer"
                src={`https://www.youtube.com/embed/${videoInfoLink[currentIndex]?.link}&autoplay=${centredModal === true?1:0}`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>

                </div>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal> */}
        </>
    )
}

export default Navbar